import { Link } from "react-router-dom";
import Slideshow from "../components/helper/slideshow";

// Images
import logo from '../images/New Logo (transparent).webp';

export default function Home() {

  return (
    <>
      <div className="home-wrapper">
        <div className="info">

          <div className="left-side font-2"> 
            <h1>VULSHOKBERSRKER </h1>
            <h4>Graphic Designer and Coder.</h4><br/>
            I started making Destiny wallpapers back when Destiny 2 Forsaken was released. 
            I wanted to transform all the lore books into beautiful wallpapers for people to enjoy.
          </div>

          <div className="right-side">
            <img src={logo} alt="logo" className="about-image"/>
          </div>
        </div>
      </div>

      <Slideshow />
      
      <div className="text-center" style={{paddingBottom: '80px', paddingTop: '20px'}}>
        <Link to='https://www.instagram.com/vulshokbersrker/' target="_blank">
          <button className="font-3 red">Contact Me</button>
        </Link>
      </div>

    </>
  );  
}
